// extracted by mini-css-extract-plugin
export default {"container":"Home_container__cLQH5","slider":"Home_slider__GBblh","animation":"Home_animation__UcsTD"};